export const modalStyle = ({
  width,
  height,
  backgroundColor = '#FFFFFF',
  overlayBackgroundColor = 'rgba(255, 255, 255, 0.75)',
  overlayPosition = 'fixed',
  overlayInset = '0px',
}) => ({
  overlay: {
    zIndex: 999,
    backgroundColor: overlayBackgroundColor,
    position: overlayPosition,
    inset: overlayInset,
  },
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width,
    height,
    backgroundColor,
  },
});
